import { c as _c } from "react/compiler-runtime";
import { VillaSearchSummaryViewPropertiesType } from "@website/accommodation-ui/villa-search/villa-search-summary/villa-search-summary.types";
import { MaterialIcon } from "@website/icons/material";
import { Skeleton } from "@website/ui/skeleton";
import { numberConvert } from "@website/utils/number-convert";
import { useRouter } from "next/router";
import { FC, ReactNode } from "react";
type PageTitleProperties = Pick<VillaSearchSummaryViewPropertiesType, "cityTitle" | "searchType" | "seoPageTitle"> & {
  isCategoryLocation: boolean;
  fallback: ReactNode;
};
const getPageTitle = ({
  cityTitle,
  searchType,
  seoPageTitle,
  isCategoryLocation,
  fallback
}: PageTitleProperties) => {
  if (seoPageTitle) return seoPageTitle;
  if (searchType === "city") {
    if (!cityTitle) return fallback;
    const villaTitlePrefix = isCategoryLocation ? "" : "اجاره ویلا";
    return `${villaTitlePrefix} ${cityTitle}`;
  }
  return cityTitle ?? fallback;
};
export const VillaSearchSummaryContent: FC<VillaSearchSummaryViewPropertiesType> = properties => {
  const $ = _c(40);
  const {
    seoPageTitle,
    searchType: t0,
    cityTitle,
    dateFrom,
    dateTo,
    passengersCount,
    nightCount
  } = properties;
  const searchType = t0 === undefined ? "city" : t0;
  const router = useRouter();
  const isCompleteInfo = dateFrom && dateTo && passengersCount;
  const t1 = router.query.locationType === "category";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Skeleton height={20} shape="rectangle" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== cityTitle || $[2] !== searchType || $[3] !== seoPageTitle || $[4] !== t1) {
    t3 = getPageTitle({
      cityTitle,
      searchType,
      seoPageTitle,
      isCategoryLocation: t1,
      fallback: t2
    });
    $[1] = cityTitle;
    $[2] = searchType;
    $[3] = seoPageTitle;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const pageTitle = t3;
  let t4;
  if ($[6] !== dateFrom || $[7] !== dateTo || $[8] !== nightCount || $[9] !== router.locale || $[10] !== searchType) {
    t4 = dateFrom && dateTo ? <span className="lg:text-on-surface-high-emphasis min-w-0 truncate lg:flex lg:min-w-24 lg:flex-row lg:items-center lg:gap-2 lg:text-center" data-testid="search_date_range">{`${dateFrom} - ${dateTo} ${searchType === "villa" ? `${numberConvert(nightCount, {
        locale: router.locale
      })} شب` : ""}`}</span> : <span className={`lg:text-on-surface-high-emphasis text-secondary min-w-0 truncate lg:flex lg:min-w-24 lg:flex-row lg:items-center lg:gap-2 lg:text-center ${searchType === "villa" ? "text-caption lg:text-subtitle-2 text-on-surface-high-emphasis" : "text-overline lg:text-subtitle-2 text-on-surface-medium-emphasis lg:text-on-surface-high-emphasis"}`} data-testid="search_date_range">تعیین بازه اقامت</span>;
    $[6] = dateFrom;
    $[7] = dateTo;
    $[8] = nightCount;
    $[9] = router.locale;
    $[10] = searchType;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const DateRange = t4;
  let t5;
  if ($[12] !== passengersCount || $[13] !== router.locale || $[14] !== searchType) {
    t5 = passengersCount ? <span className={`lg:text-on-surface-high-emphasis truncate lg:flex lg:flex-row lg:items-center lg:gap-2 lg:text-center ${searchType === "villa" ? "text-caption lg:text-subtitle-2 text-on-surface-high-emphasis" : "text-overline lg:text-subtitle-2 text-on-surface-medium-emphasis lg:text-on-surface-high-emphasis"}`}>{`${numberConvert(passengersCount, {
        locale: router.locale
      })} نفر`}</span> : <span className="lg:text-on-surface-high-emphasis text-secondary">تعداد مسافر</span>;
    $[12] = passengersCount;
    $[13] = router.locale;
    $[14] = searchType;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const PassengerInfo = t5;
  const t6 = `bg-outline-thick border-outline-thin hover:shadow-8 flex w-full min-w-0 items-center justify-between gap-4 rounded-full border px-4 py-px transition-shadow duration-200 ease-in-out lg:pl-px ${searchType === "villa" ? "h-[48px] bg-white lg:h-auto lg:max-w-max" : "bg-outline-thick lg:mx-auto lg:max-w-max"} ${isCompleteInfo ? "" : "border-secondary border-2"}`;
  let t7;
  if ($[16] !== pageTitle || $[17] !== searchType) {
    t7 = (searchType === "city" || searchType === "category") && <><h1 className="lg:text-on-surface-high-emphasis text-body-2 text-on-surface-high-emphasis lg:text-subtitle-2 truncate lg:flex lg:flex-row lg:items-center lg:gap-2 lg:text-center" data-testid="page_title">{pageTitle}</h1><div className="bg-outline-thin hidden h-[24px] w-px lg:block" /></>;
    $[16] = pageTitle;
    $[17] = searchType;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const t8 = `lg:text-on-surface-high-emphasis min-w-0 truncate lg:flex lg:flex-row lg:items-center lg:gap-2 lg:text-center ${searchType === "villa" ? "text-caption lg:text-subtitle-2 text-on-surface-high-emphasis" : "text-overline lg:text-subtitle-2 text-on-surface-medium-emphasis lg:text-on-surface-high-emphasis"}`;
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="bg-outline-thin hidden h-[24px] w-px lg:block" />;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = `${isCompleteInfo ? "" : "text-secondary"}`;
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="lg:hidden">/</span>;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10) {
    t12 = <span className={t10}>{t11}</span>;
    $[21] = t10;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== DateRange || $[24] !== PassengerInfo || $[25] !== t12 || $[26] !== t8) {
    t13 = <div className={t8}>{DateRange}{t9}{t12}{" "}{PassengerInfo}</div>;
    $[23] = DateRange;
    $[24] = PassengerInfo;
    $[25] = t12;
    $[26] = t8;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13 || $[29] !== t7) {
    t14 = <div className="grid min-w-0 grow py-1.5 lg:flex lg:flex-row lg:items-center lg:gap-4">{t7}{t13}</div>;
    $[28] = t13;
    $[29] = t7;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  const t15 = `text-on-surface-medium-emphasis lg:text-on-surface-high-emphasis flex size-6 shrink-0 grow-0 items-center justify-center rounded-full text-2xl lg:size-9 ${isCompleteInfo ? "lg:text-on-color-high-emphasis text-on-surface-medium-emphasis bg-auto" : ""} ${isCompleteInfo && searchType === "villa" ? "lg:bg-secondary" : isCompleteInfo && searchType === "city" ? "lg:bg-primary" : ""} `;
  const t16 = `${isCompleteInfo ? "text-on-surface-medium-emphasis lg:text-white" : ""}`;
  let t17;
  if ($[31] !== t16) {
    t17 = <MaterialIcon className={t16} name="search" />;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t15 || $[34] !== t17) {
    t18 = <div className={t15}>{t17}</div>;
    $[33] = t15;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t14 || $[37] !== t18 || $[38] !== t6) {
    t19 = <div className={t6}>{t14}{t18}</div>;
    $[36] = t14;
    $[37] = t18;
    $[38] = t6;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  return t19;
};